import { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { SessionContext } from "../context/SessionContext";
import { ProfileContext } from "../context/ProfileContext";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Skeleton from "react-loading-skeleton";
import Dropdown from "react-bootstrap/Dropdown";
import Nav from "react-bootstrap/Nav";
import toast from "react-hot-toast";
import ToastDisplay from "../components/ToastDisplay";
import InfoLogs from "../components/InfoLogs";
import RoleDetails from "../components/RoleDetails";

const Role = () => {
	let { id } = useParams();
	const navigate = useNavigate();
	const [session] = useContext(SessionContext);
	const [profile] = useContext(ProfileContext);
	const [loading, setLoading] = useState(true);
	const [role, setRole] = useState(null);
	const [editModal, setEditModal] = useState(false);
	const [deleteModal, setDeleteModal] = useState(false);
	const [deleteLoading, setDeleteLoading] = useState(false);
	const [actionLoading, setActionLoading] = useState(false);

	const [name, setName] = useState("");
	const [logsView, setLogsView] = useState(false);
	const [logsAdd, setLogsAdd] = useState(false);
	const [logsEdit, setLogsEdit] = useState(false);
	const [logsDelete, setLogsDelete] = useState(false);
	const [announcementsView, setAnnouncementsView] = useState(false);
	const [announcementsAdd, setAnnouncementsAdd] = useState(false);
	const [announcementsEdit, setAnnouncementsEdit] = useState(false);
	const [announcementsDelete, setAnnouncementsDelete] = useState(false);
	const [studentsView, setStudentsView] = useState(false);
	const [studentsAdd, setStudentsAdd] = useState(false);
	const [studentsEdit, setStudentsEdit] = useState(false);
	const [studentsDelete, setStudentsDelete] = useState(false);
	const [personnelView, setPersonnelView] = useState(false);
	const [personnelAdd, setPersonnelAdd] = useState(false);
	const [personnelEdit, setPersonnelEdit] = useState(false);
	const [personnelDelete, setPersonnelDelete] = useState(false);
	const [usersView, setUsersView] = useState(false);
	const [usersAdd, setUsersAdd] = useState(false);
	const [usersEdit, setUsersEdit] = useState(false);
	const [usersDelete, setUsersDelete] = useState(false);
	const [rolesView, setRolesView] = useState(false);
	const [rolesAdd, setRolesAdd] = useState(false);
	const [rolesEdit, setRolesEdit] = useState(false);
	const [rolesDelete, setRolesDelete] = useState(false);
	const [devicesView, setDevicesView] = useState(false);
	const [devicesAdd, setDevicesAdd] = useState(false);
	const [devicesEdit, setDevicesEdit] = useState(false);
	const [devicesDelete, setDevicesDelete] = useState(false);
	const [driversView, setDriversView] = useState(false);
	const [driversAdd, setDriversAdd] = useState(false);
	const [driversEdit, setDriversEdit] = useState(false);
	const [driversDelete, setDriversDelete] = useState(false);

	const [errors, setErrors] = useState([]);
	const [tab, setTab] = useState("details");

	const requiredFields = [{ key: "name", value: name }];

	const getData = async () => {
		setLoading(true);
		const requestOptions = {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				"X-Auth-Token": session,
			},
		};

		const response = await fetch(
			`${process.env.REACT_APP_API_URI}/users/roles/r/${id}`,
			requestOptions
		);
		const data = await response.json();

		if (!response.ok) {
			toast(<ToastDisplay status="error" content="Something went wrong." />);
		} else {
			setRole(data.role);
			setName(data.role.name);
			setLogsView(data.role.logs_view);
			setLogsAdd(data.role.logs_write);
			setLogsEdit(data.role.logs_edit);
			setLogsDelete(data.role.logs_delete);
			setAnnouncementsView(data.role.announcements_view);
			setAnnouncementsAdd(data.role.announcements_write);
			setAnnouncementsEdit(data.role.announcements_edit);
			setAnnouncementsDelete(data.role.announcements_delete);
			setStudentsView(data.role.students_view);
			setStudentsAdd(data.role.students_write);
			setStudentsEdit(data.role.students_edit);
			setStudentsDelete(data.role.students_delete);
			setPersonnelView(data.role.personnel_view);
			setPersonnelAdd(data.role.personnel_write);
			setPersonnelEdit(data.role.personnel_edit);
			setPersonnelDelete(data.role.personnel_delete);
			setUsersView(data.role.users_view);
			setUsersAdd(data.role.users_write);
			setUsersEdit(data.role.users_edit);
			setUsersDelete(data.role.users_delete);
			setRolesView(data.role.roles_view);
			setRolesAdd(data.role.roles_write);
			setRolesEdit(data.role.roles_edit);
			setRolesDelete(data.role.roles_delete);
			setDevicesView(data.role.devices_view);
			setDevicesAdd(data.role.devices_write);
			setDevicesEdit(data.role.devices_edit);
			setDevicesDelete(data.role.devices_delete);
			setDriversView(data.role.drivers_view);
			setDriversAdd(data.role.drivers_write);
			setDriversEdit(data.role.drivers_edit);
			setDriversDelete(data.role.drivers_delete);
		}
		setLoading(false);
	};

	const editRole = async () => {
		setActionLoading(true);
		const requestOptions = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"X-Auth-Token": session,
			},
			body: JSON.stringify({
				name: name,
				logs_view: logsView,
				logs_write: logsAdd,
				logs_edit: logsEdit,
				logs_delete: logsDelete,
				announcements_view: announcementsView,
				announcements_write: announcementsAdd,
				announcements_edit: announcementsEdit,
				announcements_delete: announcementsDelete,
				students_view: studentsView,
				students_write: studentsAdd,
				students_edit: studentsEdit,
				students_delete: studentsDelete,
				personnel_view: personnelView,
				personnel_write: personnelAdd,
				personnel_edit: personnelEdit,
				personnel_delete: personnelDelete,
				users_view: usersView,
				users_write: usersAdd,
				users_edit: usersEdit,
				users_delete: usersDelete,
				roles_view: rolesView,
				roles_write: rolesAdd,
				roles_edit: rolesEdit,
				roles_delete: rolesDelete,
				devices_view: devicesView,
				devices_write: devicesAdd,
				devices_edit: devicesEdit,
				devices_delete: devicesDelete,
				drivers_view: driversView,
				drivers_write: driversAdd,
				drivers_edit: driversEdit,
				drivers_delete: driversDelete,
			}),
		};

		const response = await fetch(
			`${process.env.REACT_APP_API_URI}/users/roles/r/${id}`,
			requestOptions
		);
		const data = await response.json();

		if (!response.ok) {
			toast(<ToastDisplay status="error" content={data.msg} />);
		} else {
			toast(<ToastDisplay status="success" content={data.msg} />);
			getData();
			closeEditModal();
		}
		setActionLoading(false);
	};

	const deleteRole = async () => {
		setDeleteLoading(true);
		const requestOptions = {
			method: "DELETE",
			headers: {
				"Content-Type": "application/json",
				"X-Auth-Token": session,
			},
		};

		const response = await fetch(
			`${process.env.REACT_APP_API_URI}/users/roles/r/${id}`,
			requestOptions
		);
		const data = await response.json();

		if (!response.ok) {
			toast(<ToastDisplay status="error" content={data.msg} />);
		} else {
			toast(<ToastDisplay status="success" content={data.msg} />);
			navigate("/property/roles");
		}
		setDeleteModal(false);
		setDeleteLoading(false);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		setActionLoading(true);
		var newErrors = [];

		requiredFields.map((field) => {
			if (!field.value || field.value === "" || field.value.length === 0) {
				newErrors.push(field.key);
			}
		});

		if (newErrors.length !== 0) {
			toast(
				<ToastDisplay
					status="error"
					content="Please fill out all required fields."
				/>
			);
			setActionLoading(false);
			setErrors(newErrors);
			return;
		}
		editRole();
	};

	const closeEditModal = () => {
		setEditModal(false);
		setName(role.name);
		setLogsView(role.logs_view);
		setLogsAdd(role.logs_write);
		setLogsEdit(role.logs_edit);
		setLogsDelete(role.logs_delete);
		setAnnouncementsView(role.announcements_view);
		setAnnouncementsAdd(role.announcements_write);
		setAnnouncementsEdit(role.announcements_edit);
		setAnnouncementsDelete(role.announcements_delete);
		setStudentsView(role.students_view);
		setStudentsAdd(role.students_write);
		setStudentsEdit(role.students_edit);
		setStudentsDelete(role.students_delete);
		setPersonnelView(role.personnel_view);
		setPersonnelAdd(role.personnel_write);
		setPersonnelEdit(role.personnel_edit);
		setPersonnelDelete(role.personnel_delete);
		setUsersView(role.users_view);
		setUsersAdd(role.users_write);
		setUsersEdit(role.users_edit);
		setUsersDelete(role.users_delete);
		setRolesView(role.roles_view);
		setRolesAdd(role.roles_write);
		setRolesEdit(role.roles_edit);
		setRolesDelete(role.roles_delete);
		setDevicesView(role.devices_view);
		setDevicesAdd(role.devices_write);
		setDevicesEdit(role.devices_edit);
		setDevicesDelete(role.devices_delete);
		setDriversView(role.drivers_view);
		setDriversAdd(role.drivers_write);
		setDriversEdit(role.drivers_edit);
		setDriversDelete(role.drivers_delete);
		setErrors([]);
	};

	const handleAnnouncementsView = () => {
		if (announcementsView) {
			setAnnouncementsAdd(false);
		}
		setAnnouncementsView(!announcementsView);
	};

	const handleStudentsView = () => {
		if (studentsView) {
			setStudentsAdd(false);
			setStudentsEdit(false);
			setStudentsDelete(false);
		}
		setStudentsView(!studentsView);
	};

	const handlePersonnelView = () => {
		if (personnelView) {
			setPersonnelAdd(false);
			setPersonnelEdit(false);
			setPersonnelDelete(false);
		}
		setPersonnelView(!personnelView);
	};

	const handleDevicesView = () => {
		if (devicesView) {
			setDevicesAdd(false);
			setDevicesEdit(false);
			setDevicesDelete(false);
		}
		setDevicesView(!devicesView);
	};

	const handleDriversView = () => {
		if (driversView) {
			setDriversAdd(false);
			setDriversEdit(false);
			setDriversDelete(false);
		}
		setDriversView(!driversView);
	};

	const handleUsersView = () => {
		if (usersView) {
			setUsersAdd(false);
			setUsersEdit(false);
			setUsersDelete(false);
		}
		setUsersView(!usersView);
	};

	const handleRolesView = () => {
		if (rolesView) {
			setRolesAdd(false);
			setRolesEdit(false);
			setRolesDelete(false);
		}
		setRolesView(!rolesView);
	};

	useEffect(() => {
		if (profile) {
			if (!profile.role.roles_view) {
				navigate("/");
			} else {
				if (id) {
					getData();
				}
			}
		}
	}, [id, profile]);

	return (
		<>
			<Container className="gx-5">
				<div className="info-page-header mb-10">
					<a
						href="#"
						className="back-btn flex-row-left fit mb-20"
						onClick={(e) => {
							e.preventDefault();
							navigate(-1);
						}}
					>
						<i className="ri-arrow-left-line opacity-7" />
						<span className="text-sm text-regular-inter upper opacity-7">
							Roles
						</span>
					</a>
					<Row className="flex-row-left">
						<Col className="flex-row-left">
							<div className="contact-icon flex-column rounded-8">
								<span className="text-bold-gotham text-md">
									{role?.name[0]}
								</span>
							</div>
							<h1 className="text-lg mb-0 text-medium-gotham">
								{loading ? (
									<Skeleton
										width={250}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : (
									role?.name || "--"
								)}
							</h1>
						</Col>
						<Col className="flex-row-right">
							{role?.name !== "Administrator" &&
								(profile?.role?.roles_edit || profile?.role?.roles_delete ? (
									<Dropdown>
										<Dropdown.Toggle
											variant="light"
											className="info-control-btn text-lg rounded-4 flex-column no-arrow"
											disabled={loading}
										>
											<i className="ri-more-2-fill me-0" />
										</Dropdown.Toggle>
										<Dropdown.Menu className="text-sm dropdown-default">
											{profile?.role?.roles_edit && (
												<Dropdown.Item
													href="#"
													onClick={(e) => {
														e.preventDefault();
														setEditModal(true);
													}}
												>
													Edit
												</Dropdown.Item>
											)}
											{profile?.role?.roles_delete && (
												<Dropdown.Item
													href="#"
													className="text-danger"
													onClick={() => setDeleteModal(true)}
												>
													Delete
												</Dropdown.Item>
											)}
										</Dropdown.Menu>
									</Dropdown>
								) : (
									""
								))}
						</Col>
					</Row>
				</div>
				<Nav variant="tabs" defaultActiveKey={tab} className="mb-20">
					<Nav.Item>
						<Nav.Link
							eventKey="details"
							className="info-tab-item"
							onClick={() => setTab("details")}
						>
							Details
						</Nav.Link>
					</Nav.Item>
					<Nav.Item>
						<Nav.Link
							eventKey="logs"
							className="info-tab-item"
							onClick={() => setTab("logs")}
						>
							Logs
						</Nav.Link>
					</Nav.Item>
				</Nav>
				{tab === "details" && <RoleDetails loading={loading} role={role} />}
				{tab === "logs" && <InfoLogs loading={loading} data={role} />}
			</Container>
			<Modal
				show={editModal}
				className="info-modal"
				size="lg"
				centered
				onHide={closeEditModal}
			>
				<Form onSubmit={handleSubmit}>
					<Modal.Header>
						<Modal.Title className="text-lg">Edit Role</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="mb-10">
							<h2 className="text-lg text-medium-gotham mb-0">
								Role Information
							</h2>
						</div>
						<Row className="mb-30">
							<Col>
								<Form.Label className="text-sm">Name*</Form.Label>
								<Form.Control
									autoFocus
									className={`text-sm form-input ${
										errors.includes("name") && "border-danger"
									}`}
									value={name}
									onChange={(e) => setName(e.target.value)}
								/>
							</Col>
						</Row>
						<div className="mb-10">
							<h2 className="text-lg text-medium-gotham mb-0">Permissions</h2>
						</div>
						<div className="border rounded-8 p-20 mb-20">
							<div className="mb-20">
								<span className="text-medium-gotham">Logs</span>
							</div>
							<Row>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={logsView}
										id="logsView"
										onChange={() => setLogsView(!logsView)}
									/>
									<label htmlFor="logsView" className="lbl m-0" />
									<span className="text-sm ms-3">View</span>
								</Col>
								<Col />
								<Col />
								<Col />
							</Row>
						</div>
						<div className="border rounded-8 p-20 mb-20">
							<div className="mb-20">
								<span className="text-medium-gotham">Announcements</span>
							</div>
							<Row>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={announcementsView}
										id="announcementsView"
										onChange={handleAnnouncementsView}
									/>
									<label htmlFor="announcementsView" className="lbl m-0" />
									<span className="text-sm ms-3">View</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={announcementsAdd}
										id="announcementsAdd"
										onChange={() => {
											setAnnouncementsAdd(!announcementsAdd);
											setAnnouncementsView(true);
										}}
									/>
									<label htmlFor="announcementsAdd" className="lbl m-0" />
									<span className="text-sm ms-3">Add</span>
								</Col>
								<Col />
								<Col />
							</Row>
						</div>
						<div className="border rounded-8 p-20 mb-20">
							<div className="mb-20">
								<span className="text-medium-gotham">Students</span>
							</div>
							<Row>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={studentsView}
										id="studentsView"
										onChange={handleStudentsView}
									/>
									<label htmlFor="studentsView" className="lbl m-0" />
									<span className="text-sm ms-3">View</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={studentsAdd}
										id="studentsAdd"
										onChange={() => {
											setStudentsAdd(!studentsAdd);
											setStudentsView(true);
										}}
									/>
									<label htmlFor="studentsAdd" className="lbl m-0" />
									<span className="text-sm ms-3">Add</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={studentsEdit}
										id="studentsEdit"
										onChange={() => {
											setStudentsEdit(!studentsEdit);
											setStudentsView(true);
										}}
									/>
									<label htmlFor="studentsEdit" className="lbl m-0" />
									<span className="text-sm ms-3">Edit</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={studentsDelete}
										id="studentsDelete"
										onChange={() => {
											setStudentsDelete(!studentsDelete);
											setStudentsView(true);
										}}
									/>
									<label htmlFor="studentsDelete" className="lbl m-0" />
									<span className="text-sm ms-3">Delete</span>
								</Col>
							</Row>
						</div>
						<div className="border rounded-8 p-20 mb-20">
							<div className="mb-20">
								<span className="text-medium-gotham">Personnel</span>
							</div>
							<Row>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={personnelView}
										id="personnelView"
										onChange={handlePersonnelView}
									/>
									<label htmlFor="personnelView" className="lbl m-0" />
									<span className="text-sm ms-3">View</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={personnelAdd}
										id="personnelAdd"
										onChange={() => {
											setPersonnelAdd(!personnelAdd);
											setPersonnelView(true);
										}}
									/>
									<label htmlFor="personnelAdd" className="lbl m-0" />
									<span className="text-sm ms-3">Add</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={personnelEdit}
										id="personnelEdit"
										onChange={() => {
											setPersonnelEdit(!personnelEdit);
											setPersonnelView(true);
										}}
									/>
									<label htmlFor="personnelEdit" className="lbl m-0" />
									<span className="text-sm ms-3">Edit</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={personnelDelete}
										id="personnelDelete"
										onChange={() => {
											setPersonnelDelete(!personnelDelete);
											setPersonnelView(true);
										}}
									/>
									<label htmlFor="personnelDelete" className="lbl m-0" />
									<span className="text-sm ms-3">Delete</span>
								</Col>
							</Row>
						</div>
						<div className="border rounded-8 p-20 mb-20">
							<div className="mb-20">
								<span className="text-medium-gotham">Devices</span>
							</div>
							<Row>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={devicesView}
										id="devicesView"
										onChange={handleDevicesView}
									/>
									<label htmlFor="devicesView" className="lbl m-0" />
									<span className="text-sm ms-3">View</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={devicesAdd}
										id="devicesAdd"
										onChange={() => {
											setDevicesAdd(!devicesAdd);
											setDevicesView(true);
										}}
									/>
									<label htmlFor="devicesAdd" className="lbl m-0" />
									<span className="text-sm ms-3">Add</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={devicesEdit}
										id="devicesEdit"
										onChange={() => {
											setDevicesEdit(!devicesEdit);
											setDevicesView(true);
										}}
									/>
									<label htmlFor="devicesEdit" className="lbl m-0" />
									<span className="text-sm ms-3">Edit</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={devicesDelete}
										id="devicesDelete"
										onChange={() => {
											setDevicesDelete(!devicesDelete);
											setDevicesView(true);
										}}
									/>
									<label htmlFor="devicesDelete" className="lbl m-0" />
									<span className="text-sm ms-3">Delete</span>
								</Col>
							</Row>
						</div>
						<div className="border rounded-8 p-20 mb-20">
							<div className="mb-20">
								<span className="text-medium-gotham">Drivers</span>
							</div>
							<Row>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={driversView}
										id="driversView"
										onChange={handleDriversView}
									/>
									<label htmlFor="driversView" className="lbl m-0" />
									<span className="text-sm ms-3">View</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={driversAdd}
										id="driversAdd"
										onChange={() => {
											setDriversAdd(!driversAdd);
											setDriversView(true);
										}}
									/>
									<label htmlFor="driversAdd" className="lbl m-0" />
									<span className="text-sm ms-3">Add</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={driversEdit}
										id="driversEdit"
										onChange={() => {
											setDriversEdit(!driversEdit);
											setDriversView(true);
										}}
									/>
									<label htmlFor="driversEdit" className="lbl m-0" />
									<span className="text-sm ms-3">Edit</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={driversDelete}
										id="driversDelete"
										onChange={() => {
											setDriversDelete(!driversDelete);
											setDriversView(true);
										}}
									/>
									<label htmlFor="driversDelete" className="lbl m-0" />
									<span className="text-sm ms-3">Delete</span>
								</Col>
							</Row>
						</div>
						<div className="border rounded-8 p-20 mb-20">
							<div className="mb-20">
								<span className="text-medium-gotham">Users</span>
							</div>
							<Row>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={usersView}
										id="usersView"
										onChange={handleUsersView}
									/>
									<label htmlFor="usersView" className="lbl m-0" />
									<span className="text-sm ms-3">View</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={usersAdd}
										id="usersAdd"
										onChange={() => {
											setUsersAdd(!usersAdd);
											setUsersView(true);
										}}
									/>
									<label htmlFor="usersAdd" className="lbl m-0" />
									<span className="text-sm ms-3">Add</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={usersEdit}
										id="usersEdit"
										onChange={() => {
											setUsersEdit(!usersEdit);
											setUsersView(true);
										}}
									/>
									<label htmlFor="usersEdit" className="lbl m-0" />
									<span className="text-sm ms-3">Edit</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={usersDelete}
										id="usersDelete"
										onChange={() => {
											setUsersDelete(!usersDelete);
											setUsersView(true);
										}}
									/>
									<label htmlFor="usersDelete" className="lbl m-0" />
									<span className="text-sm ms-3">Delete</span>
								</Col>
							</Row>
						</div>
						<div className="border rounded-8 p-20 mb-20">
							<div className="mb-20">
								<span className="text-medium-gotham">Roles & Permissions</span>
							</div>
							<Row>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={rolesView}
										id="rolesView"
										onChange={handleRolesView}
									/>
									<label htmlFor="rolesView" className="lbl m-0" />
									<span className="text-sm ms-3">View</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={rolesAdd}
										id="rolesAdd"
										onChange={() => {
											setRolesAdd(!rolesAdd);
											setRolesView(true);
										}}
									/>
									<label htmlFor="rolesAdd" className="lbl m-0" />
									<span className="text-sm ms-3">Add</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={rolesEdit}
										id="rolesEdit"
										onChange={() => {
											setRolesEdit(!rolesEdit);
											setRolesView(true);
										}}
									/>
									<label htmlFor="rolesEdit" className="lbl m-0" />
									<span className="text-sm ms-3">Edit</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={rolesDelete}
										id="rolesDelete"
										onChange={() => {
											setRolesDelete(!rolesDelete);
											setRolesView(true);
										}}
									/>
									<label htmlFor="rolesDelete" className="lbl m-0" />
									<span className="text-sm ms-3">Delete</span>
								</Col>
							</Row>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Button
							variant="outline-secondary"
							className="btn-sm action-btn text-sm me-2"
							onClick={closeEditModal}
						>
							Close
						</Button>
						<Button
							type="submit"
							variant="primary"
							className="btn-sm action-btn text-sm btn-default"
							disabled={actionLoading}
						>
							{actionLoading ? (
								<Spinner className="btn-loader text-white" />
							) : (
								"Save Changes"
							)}
						</Button>
					</Modal.Footer>
				</Form>
			</Modal>
			<Modal show={deleteModal} onHide={() => setDeleteModal(false)}>
				<Modal.Body>
					<h2 className="text-lg text-medium-inter mb-15">Delete Role</h2>
					<p className="text-sm opacity-7">
						Are you sure you want to delete this role? This action cannot be
						undone.
					</p>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="light"
						className="modal-btn btn-sm dismiss-btn text-medium-inter text-sm"
						onClick={() => setDeleteModal(false)}
					>
						Cancel
					</Button>
					<Button
						variant="danger"
						className="action-btn btn-sm text-medium-inter text-sm flex-column"
						disabled={deleteLoading}
						onClick={deleteRole}
					>
						{deleteLoading ? (
							<Spinner className="btn-loader text-white" />
						) : (
							"Delete"
						)}
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default Role;
